import styled,{default as _styled,default as _styled2,default as _styled3}from'styled-components';import BetaIcon from"../../../assets/BetaIcon";import ParadexLogoIcon from"../../../assets/ParadexLogoIcon";import ParadexLogoText from"../../../assets/ParadexLogoText";import{mdVisible,MEDIA,smVisible}from"../../../features/layout/media-queries";import{jsx as _jsx,jsxs as _jsxs}from"react/jsx-runtime";var _StyledParadexLogoIcon=_styled2(ParadexLogoIcon)`${smVisible}`;var _StyledParadexLogoText=/*#__PURE__*/_styled3(ParadexLogoText).withConfig({displayName:"Logo___StyledParadexLogoText",componentId:"qr0or9-0"})(["",""],mdVisible);export default function Logo(){return/*#__PURE__*/_jsxs(_StyledLogoContainer,{children:[/*#__PURE__*/_jsx(_StyledParadexLogoIcon,{}),/*#__PURE__*/_jsx(_StyledParadexLogoText,{}),/*#__PURE__*/_jsx(BetaIcon,{})]});}const LogoContainer=styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 24px;

  &:first-child {
    margin-left: -8px;
  }

  @media ${MEDIA.md} {
    &:first-child {
      margin-left: 0px;
    }
  }
`;var _StyledLogoContainer=_styled(LogoContainer)`grid-area: logo;`;